var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMexc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 36,
    viewBox: "0 0 122 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5100_20293)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5100_20293",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 122,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 0H0.5V36H121.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5100_20293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0248 22.5285L31.338 7.4603C29.4337 4.31971 24.7896 4.2863 22.952 7.59393L13.831 23.2635C12.127 26.1368 14.2318 29.7451 17.6398 29.7451H35.9152C39.3566 29.7451 41.9292 26.0365 40.0248 22.5285Z",
    fill: "#3156AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4958 23.6979L26.9613 22.7624C26.4602 21.8936 25.3576 20.0227 25.3576 20.0227L18.0073 7.2599C16.1029 4.42001 11.5925 4.18614 9.68812 7.76106L1.13505 22.5619C-0.635705 25.669 1.46915 29.7117 5.31136 29.7452H23.4866H31.2378H35.8485C31.1376 29.7786 29.6342 27.3395 27.4958 23.6979Z",
    fill: "#1972E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.496 23.6978L26.9614 22.7624C26.4603 21.8937 25.3577 20.0227 25.3577 20.0227L20.6134 11.67L13.7977 23.2969C12.0939 26.1702 14.1987 29.7785 17.6066 29.7785H23.4533H31.2046H35.8487C31.1044 29.7451 29.6342 27.3396 27.496 23.6978Z",
    fill: "url(#paint0_linear_5100_20293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5127 28.4082V11.0013H83.9794V12.1039C83.9794 12.9726 83.2778 13.6742 82.4092 13.6742H73.121V18.3516H82.4092V21.0245H73.121V25.7019H82.4092C83.2778 25.7019 83.9794 26.4035 83.9794 27.2722V28.3748L69.5127 28.4082Z",
    fill: "#EDEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.762 11.0013H101.354C100.719 11.0013 100.151 11.2686 99.7501 11.7698L95.6406 16.9484L91.5311 11.8032C91.1302 11.302 90.5622 11.0347 89.9275 11.0347H86.5195L93.4355 19.7215L86.5195 28.4082H89.9275C90.5622 28.4082 91.1302 28.1409 91.5311 27.6398L95.6406 22.4946L99.7835 27.6732C100.184 28.1409 100.752 28.4416 101.387 28.4416H104.795L97.8791 19.7548L104.762 11.0013Z",
    fill: "#EDEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1877 26.5718L62.932 18.286V28.376H66.5404V10.9691H64.3018C63.6002 10.9691 62.932 11.3366 62.5979 11.9714L56.9181 22.3286L51.2384 11.9714C50.9042 11.3366 50.236 10.9691 49.5343 10.9691H47.2959V28.376H50.9042V18.286L55.6485 26.5718H58.1877Z",
    fill: "#EDEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.183 28.6089C109.171 28.6757 105.095 24.7332 105.062 19.7217C105.062 16.9821 105.897 14.7101 107.467 13.1398C109.037 11.603 111.309 10.7677 114.016 10.7677C117.189 10.7677 119.695 11.8702 121.499 14.0085L120.364 14.9774C119.662 15.5788 118.626 15.6122 117.858 15.0442C116.855 14.2758 115.586 13.9083 114.149 13.9083C110.608 13.9083 108.503 16.0466 108.503 19.6549C108.503 23.2966 110.674 25.5352 114.149 25.5352C115.619 25.5352 116.855 25.1342 117.858 24.3992C118.593 23.8311 119.628 23.8647 120.364 24.466L121.499 25.4349C119.695 27.5397 117.29 28.6089 114.183 28.6089Z",
    fill: "#EDEFF2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5100_20293",
    x1: 11.372,
    y1: 18.014,
    x2: 32.4868,
    y2: 25.8168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#264CA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234588"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5100_20293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 36,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexc);
export default __webpack_public_path__ + "static/media/mexc.b0f0188a60b7e5c3bda11773eff7f2b3.svg";
export { ForwardRef as ReactComponent };